import * as Sentry from '@sentry/react';
import { Offer } from '~entities/offer/model/offer.types';
import { CartItem, LastBooking, Session } from '../model/session.types';
import {
  AddToCartDto,
  LastBookingDto,
  SessionDto,
  UpdateCartItemDto,
} from '~shared/api/api.types';

export const transformSessionDtoToSession = ({
  items,
  ...sessionDto
}: SessionDto): Session => {
  return {
    ...sessionDto,
    cart: items.map(({ roomCategoryId, packageGroupId, ...offer }) => ({
      ...offer,
      roomId: roomCategoryId,
      packageId: packageGroupId,
    })),
    promotionCode: sessionDto.promotion?.code,
  };
};

export const transformOfferToAddToCartDto = (offer: Offer): AddToCartDto => {
  // TODO: in future no throw errors, make more type safe api
  if (
    !offer.type ||
    !offer.adults ||
    !offer.children ||
    !offer.price ||
    !offer.rateId ||
    !offer.roomId
  ) {
    const missingFields: string[] = [];
    if (!offer.type) missingFields.push('type');
    if (!offer.adults) missingFields.push('adults');
    if (!offer.children) missingFields.push('children');
    if (!offer.price) missingFields.push('price');
    if (!offer.rateId) missingFields.push('rateId');
    if (!offer.roomId) missingFields.push('roomId');

    const message = `Invalid offer: missing ${missingFields.join(', ')}`;
    Sentry.captureException(new Error(message), {
      // Force a stable fingerprint so all missing-field combinations stay
      // grouped under one Sentry issue. The unhandled rejection from the
      // throw below is grouped via the same fingerprint in instrument.ts.
      fingerprint: ['invalid-offer'],
      contexts: { offer: { ...offer } as Record<string, unknown> },
      tags: { missingOfferFields: missingFields.join(',') },
    });
    throw new Error(message);
  }

  return {
    type: offer.type,
    arrivalDay: offer.arrivalDay,
    nights: offer.nights,
    adults: offer.adults,
    children: offer.children,
    price: offer.price,

    rateId: offer.rateId,
    roomCategoryId: offer.roomId,

    lastMinutePackageId: offer.lastMinutePackageId,
    packageGroupId: offer.packageId,
    packageCategoryId: offer.packageCategoryId,
  };
};

export const transformCartItemToUpdateCartItemDto = ({
  roomId,
  ...cartItem
}: CartItem): UpdateCartItemDto => {
  return {
    ...cartItem,
    roomCategoryId: roomId,
  };
};

export const transformLastBookingDtoToLastBooking = (
  lastBookingDto: LastBookingDto,
): LastBooking => {
  return {
    ...lastBookingDto,
  };
};
